import { api } from "./client";

export type FeatureRow = {
  source: string;
  tool_name: string | null;
  count: number;
  failures: number;
  failure_rate: number;
};

export type HourlyRow = { hour: number; count: number };

export type ErrorRow = {
  model: string | null;
  status_code: string | null;
  count: number;
};

export const featuresApi = {
  breakdown: (days = 7) => api.get<FeatureRow[]>(`/features/breakdown?period_days=${days}`),
  hourly: (days = 7) => api.get<HourlyRow[]>(`/features/hourly?period_days=${days}`),
  errors: (days = 7) => api.get<ErrorRow[]>(`/features/errors?period_days=${days}`),
};
